export const FETCH_UPDATE_USER_PROFILE_REQUEST = 'FETCH_UPDATE_USER_PROFILE_REQUEST'
export const FETCH_UPDATE_USER_PROFILE_SUCCESS = 'FETCH_UPDATE_USER_PROFILE_SUCCESS'
export const FETCH_UPDATE_USER_PROFILE_FALUIRE = 'FETCH_UPDATE_USER_PROFILE_FALUIRE'
